import type { PlatformConfig } from '~/repositories/PlatformRepository';

interface InternationalWireDetailState {
  hasData: boolean;
  isError: boolean;
  isFetching: boolean;
  isLoading: boolean;
}

export const isInternationalWireApprovalBlocked = (
  transferType: string | undefined,
  detailState: InternationalWireDetailState | undefined
): boolean =>
  transferType === 'swift' &&
  (!detailState || !detailState.hasData || detailState.isError || detailState.isFetching || detailState.isLoading);

export const isReviewRequired = (
  type: string,
  transferApprovalConfig: PlatformConfig['transferApprovalConfig'] | undefined,
  enableSwiftTransferApprovals: boolean
): boolean => {
  if (!transferApprovalConfig) return false;

  switch (type) {
    case 'ach_credit':
      return transferApprovalConfig.enabledForAchCredits ?? false;
    case 'ach_debit':
      return transferApprovalConfig.enabledForAchDebits ?? false;
    case 'issue-check':
      return transferApprovalConfig.enabledForCheckDebits ?? false;
    case 'intl-wire':
      return enableSwiftTransferApprovals && (transferApprovalConfig.enabledForInternationalWire ?? false);
    case 'wire':
      return transferApprovalConfig.enabledForWire ?? false;
    case 'realtime':
      return transferApprovalConfig.enabledForRealtime ?? false;
    default:
      return false;
  }
};
